<template>
  <div id="mainContent" class="scene-detail content">
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
        <span class="fontStyle1">{{ $t("yhubReport.Machine") }}:{{ basicinfo.mechBrand }}
          {{ basicinfo.mechModel }}</span>
        <!--设备-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.BatteryInformation") }}:{{ basicinfo.batteryBrand }}
          {{ basicinfo.batteryModels }} </span>
        <!--电池型号-->
        <span v-if="basicinfo.batteryCapacity!=null" class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryCapacity }} Ah
        </span><!-- 容量-->
        <span class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryVoltage }} V </span>
        <!--系统电压-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}:V{{ basicinfo.fwVersion }}</span>
        <!--固件-->
      </div>
    </el-row>
    <!-- 日期选择器 -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:20px;background:white;position:relative;">
        <div class="searchWarp">
          <el-date-picker v-model="selectDate" type="daterange" :range-separator="$t('AllDevices.to')"
            :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" />
        </div>
        <el-button v-if="$store.state.userInfo.guestFlag!=true" icon="el-icon-download" size="mini"
          style="vertical-align: top;margin:5px 10px;float: right;position: relative;z-index: 999;" type="primary"
          @click="download" />
        <el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane :label="$t('charger.BLEbroadcast')" name="broadcastPane" style="position:relative;" />
          <el-tab-pane :label="$t('charger.app_operation')" name="event" style="position:relative;" />
          
          <div v-if="activeTab=='broadcastPane'">
            <!-- 广播数据 -->
            <el-table v-loading="loadBroad" :data="broadcastList" border style="width: auto" fit class="myTable">
              <el-table-column :label="$t('warningPage.CreatedAt')" prop="CreatedAt" align="center" width="160px" />
              <el-table-column :label="$t('warningPage.SOC')+'(%)'" prop="soc" align="center" />
              <el-table-column :label="$t('AllDevices.Current')+'(A)'" prop="current" align="center" />
              <el-table-column :label="$t('basicinfo.Voltage')+'(V)'" prop="valtage" align="center" />
              <el-table-column :label="$t('warningPage.temperature')" prop="" align="center">
                <template slot-scope="scope">
                  <p v-if="scope.row.tem<'-20'" class="infoP">{{ $t('allDeviceDetail.NotInstalled') }}</p>
                  <p v-else-if="scope.row.tem>=120" class="infoP">{{ $t('basicinfo.AbnormalTemperature') }}</p>
                  <p v-else-if="!scope.row.tem&&scope.row.tem!=0" class="infoP">--</p>
                  <!-- <p v-else class="infoP">{{ scope.row.tem }} ℃</p> -->
                  <p v-else class="infoP">{{ scope.row.temS }} </p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('warningPage.Level')" prop="" align="center">
                <template slot-scope="scope">
                  <p v-if="scope.row.waterLevel=='-1'" class="infoP">{{ $t('allDeviceDetail.NotInstalled') }}</p>
                  <p v-if="scope.row.waterLevel===0" class="infoP" style="color:red;">{{ $t('allDeviceDetail.Bad') }}
                  </p>
                  <p v-if="scope.row.waterLevel=='1'" class="infoP">{{ $t('allDeviceDetail.Normal') }}</p>
                  <p v-if="!scope.row.waterLevel&&scope.row.waterLevel!='0'" class="infoP">--</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('AllDevices.Status')" prop="chargedTime" align="center">
                <template slot-scope="scope">
                  <div>
                    <p v-if="scope.row.batteryState=='idel'">{{ $t('basicinfo.Idle') }}</p>
                    <p v-else-if="scope.row.batteryState=='charge'">{{ $t('basicinfo.Charging') }}</p>
                    <p v-else-if="scope.row.batteryState=='discharge'">{{ $t('basicinfo.DisCharging') }}</p>
                    <p v-else>--</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="RSSI" prop="RSSI" align="center" />
              <el-table-column :label="$t('QR.Uploader')" prop="createBy" align="center" />
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
                  :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
                  @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>
            </div>
          </div>
          <div v-if="activeTab=='realData'">
            <!-- 实时数据 -->
            <el-table v-loading="loadRealData" :data="realDataList" border style="width: auto" fit class="myTable">
              <el-table-column :label="$t('warningPage.CreatedAt')" prop="CreatedAt" align="center" />
              <el-table-column :label="$t('warningPage.SOC')+'(%)'" prop="soc" align="center" />
              <el-table-column :label="$t('AllDevices.Current')+'(A)'" prop="current" align="center" />
              <el-table-column :label="$t('basicinfo.Voltage')+'(V)'" prop="valtage" align="center" />
              <el-table-column :label="$t('warningPage.temperature')" prop="" align="center">
                <template slot-scope="scope">
                  <p v-if="scope.row.tem<'-20'" class="infoP">{{ $t('allDeviceDetail.NotInstalled') }}</p>
                  <p v-else-if="scope.row.tem>=120" class="infoP">{{ $t('basicinfo.AbnormalTemperature') }}</p>
                  <p v-else-if="!scope.row.tem&&scope.row.tem!=0" class="infoP">--</p>
                  <!-- <p v-else class="infoP">{{ scope.row.tem }} ℃</p> -->
                  <p v-else class="infoP">{{ scope.row.temS }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('AllDevices.Status')" prop="statu" align="center">
                <template slot-scope="scope">
                  <div>
                    <p v-if="scope.row.statu=='idel'">{{ $t('basicinfo.Idle') }}</p>
                    <p v-else-if="scope.row.statu=='charge'">{{ $t('basicinfo.Charging') }}</p>
                    <p v-else-if="scope.row.statu=='discharge'">{{ $t('basicinfo.DisCharging') }}</p>
                    <p v-else>--</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('QR.Uploader')" prop="createBy" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.createBy }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column :label="$t('QR.Uploader')+'88888888'" prop="aa" align="center" /> -->
            </el-table>
            <!-- 列表模块————分页 -->
            <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
              <div class="pagination-container">
                <el-pagination v-if="pageshow1" background current-page.sync="listQuery.pageInfo.page"
                  :page-sizes="listQuery1.pageInfo.pageList" :page-size="listQuery1.pageInfo.limit"
                  layout="total, sizes, prev, pager, next, jumper" :total="listQuery1.pageInfo.total"
                  @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
              </div>
            </div>
          </div>
          <div v-if="activeTab=='meterReadPane'">
            <lineChartYhubBle :line-chart-data="lineChartData" :height="lineHeight" :sn="basicinfo.deviceSn" />
          </div>

          <event-logs v-if="activeTab=='event'" :selectDay="selectDate" :sn="basicinfo.deviceSn"></event-logs>
          
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { pageBluetoothDetail, listBluetoothDetail } from '@/api/blueTooth'
import { findDeviceInfo } from '@/api/yhub'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime'
import lineChartYhubBle from '@/components/lineChartYhubBle'
import { temChange, temChangeUnit } from '@/utils/temChange.js'
import EventLogs from './EventLogs.vue'
export default {
  components: { lineChartYhubBle, EventLogs },
  data () {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      // 分页----start
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页----end
      basicinfo: {},
      selectDate: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000], // 默认一周
      activeTab: 'broadcastPane',
      broadcastList: [],
      loadRealData: true,
      realDataList: [],
      lineChartData: {
        sn: '',
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        d12: [],
        d13: []
      },
      lineHeight: '600px',
      loadBroad: true,
      typeNum: 6
    }
  },
  watch: {
    activeTab (newValue, oldValue) {
      if (newValue == 'broadcastPane') {
        this.typeNum = 6
        this.queryBroadcast()// 获取广播数据
      } else if (newValue == 'realData') {
        this.typeNum = 8
        this.queryRealData()// 获取实时数据
      } else if (newValue == 'meterReadPane') {
        this.typeNum = 7
        this.queryMeterRead()// 获取抄表数据
      }
    },
    selectDate: {
      handler (newValue, oldValue) {
        if ((!newValue || this.selectDate.length == 0) && oldValue) { // 如果点击清空日期，则默认为一个月
          this.selectDate = [new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000, Date.now()]
          this.changeSelectDate()
        } else if (newValue && oldValue) {
          this.changeSelectDate()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.queryBaseInfo()// 获取基本数据
    this.queryBroadcast()// 获取广播数据
  },
  methods: {
    queryBaseInfo () { // 获取基本数据
      var param1 = {
        mcuId: this.$route.query.mcuId
      }
      findDeviceInfo(param1).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.basicinfo = res.resultModel
        if (this.basicinfo.batteryVoltage) { this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? (this.basicinfo.batteryVoltage / 100) : this.basicinfo.batteryVoltage } else { this.basicinfo.batteryVoltage = '--' }
        if (this.basicinfo.batteryCapacity) { this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 100 ? Math.round(this.basicinfo.batteryCapacity / 100) : this.basicinfo.batteryCapacity } else { this.basicinfo.batteryCapacity = '--' }
      })
    },
    queryBroadcast () { // 获取广播数据
      var param = {
        'startDate': new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000,
        'endDate': new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000,
        'mcuId': this.$route.query.mcuId,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 6 // 数据类型: 1yhub，2蓝牙充电器广播数据，3蓝牙充电器日志，4逆变器，5锂电池，6yhub广播数据，7yhub蓝牙抄表数据,8实时数据
      }
      if (this.selectDate && this.selectDate.length > 0) {
        param.startDate = new Date(this.selectDate[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDate[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      this.loadBroad = true
      pageBluetoothDetail(param).then(res => {
        this.loadBroad = false
        this.broadcastList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy
          obj.temS = temChangeUnit(obj.tem)
          this.broadcastList.push(obj)
        })
        this.broadcastList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.nowData, 'noSecond')
        })
        this.listQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryMeterRead () { // 获取抄表数据
      var param1 = {
        'startDate': new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000,
        'endDate': new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000,
        'mcuId': this.$route.query.mcuId,
        'showAll': false,
        'type': 7 // 数据类型: 1yhub，2蓝牙充电器广播数据，3蓝牙充电器日志，4逆变器，5锂电池，6yhub广播数据，7yhub蓝牙抄表数据,8实时数据
      }
      if (this.selectDate && this.selectDate.length > 0) {
        param1.startDate = new Date(this.selectDate[0]).setHours(0, 0, 0, 0)
        param1.endDate = new Date(this.selectDate[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      listBluetoothDetail(param1).then(res => { // 基本信息
        for (const i in this.lineChartData) {
          this.lineChartData[i] = []
        }
        if (res.resultCode != 1001 || !res.resultModel) return
        var dataList = res.resultModel || []
        // dataList.push({ jsonData: '{}' }, { jsonData: '{}' }, { jsonData: '{}' }) // 假数据
        // dataList[2] = dataList[1] = dataList[0] // 假数据
        // var num = 0 // 假数据
        for (const i in dataList) {
          // num = num + 1000
          var str = dataList[i].jsonData
          if (str.indexOf('\\') > -1) str = str.replace(/\//g, '')
          var data = JSON.parse(str) || {}
          var time = data.yhubStime * 1000
          if (!data.chargedah) data.chargedah = 0
          if (!data.usedah) data.usedah = 0
          if (!data.voltageRaw) data.voltageRaw = 0
          if (!data.batteryTemperature) data.batteryTemperature = 0
          if (!data.soc) data.soc = 0
          this.lineChartData.d3.push([time, (data.chargedah / 100).toFixed(2)])
          this.lineChartData.d4.push([time, (data.usedah / 100).toFixed(2)])
          this.lineChartData.d5.push([time, (data.voltageRaw / 100).toFixed(2)])
          this.lineChartData.d6.push([time, temChange(Math.round(data.batteryTemperature / 100))])
          this.lineChartData.d7.push([time, Math.round(data.soc / 100)])

          this.lineChartData.d8.push([time, data.accelX ? data.accelX : 0])
          this.lineChartData.d9.push([time, data.accelY ? data.accelY : 0])
          this.lineChartData.d10.push([time, data.accelZ ? data.accelZ : 0])
          this.lineChartData.d11.push([time, data.yaw ? data.yaw : 0])
          this.lineChartData.d12.push([time, data.roll ? data.roll : 0])
          this.lineChartData.d13.push([time, data.pitch ? data.pitch : 0])
        }
        console.log('this.lineChartData', this.lineChartData)
      })
    },
    queryRealData () { // 获取实时数据
      var param1 = {
        'startDate': new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000,
        'endDate': new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000,
        'mcuId': this.$route.query.mcuId,
        pageNum: this.listQuery1.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery1.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 8 // 数据类型: 1yhub，2蓝牙充电器广播数据，3蓝牙充电器日志，4逆变器，5锂电池，6yhub广播数据，7yhub蓝牙抄表数据,8实时数据
      }
      if (this.selectDate && this.selectDate.length > 0) {
        param1.startDate = new Date(this.selectDate[0]).setHours(0, 0, 0, 0)
        param1.endDate = new Date(this.selectDate[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      this.loadRealData = true
      pageBluetoothDetail(param1).then(res => {
        this.loadRealData = false
        this.realDataList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        var dataList1 = res.resultModel.list || []
        dataList1.forEach(v => {
          var obj = {}
          obj.CreatedAt = getDateAndHour(v.yhubTime, 'noSecond')

          var dataObj = JSON.parse(v.jsonData) || { dRecord: {} }
          var dRecord = dataObj.dRecord
          obj.valtage = Number((dRecord.voltageRaw / 100).toFixed(2))
          if (!dRecord.currentCharging) dRecord.currentCharging = 0
          if (!dRecord.currentDischarging) dRecord.currentDischarging = 0
          obj.current = (dRecord.currentCharging - dRecord.currentDischarging) ? ((dRecord.currentCharging - dRecord.currentDischarging) / 100).toFixed(2) : 0
          obj.soc = dRecord.soc ? Math.floor(dRecord.soc / 100) : 0  // 电量向下取整，与广播数据同步
          obj.tem = Math.round(dRecord.batteryTemperature / 100)
          obj.temS = temChangeUnit(obj.tem)
          if (obj.current == 0 || !obj.current) {
            obj.statu = 'idel'
          } else if (obj.current > 0) { // 放电：负；充电：正
            obj.statu = 'charge'
          } else {
            obj.statu = 'discharge'
          }
          obj.createBy = v.createBy
          this.realDataList.push(obj)
        })
        this.listQuery1.pageInfo.total = res.resultModel.total // 分页
      })
    },
    changeSelectDate () { // 改变日期选择
      if (this.activeTab == 'broadcastPane') { // 获取广播数据
        this.listQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryBroadcast()
        this.$nextTick(() => {
          this.pageshow = true
        })
      }
      if (this.activeTab == 'realData') { // 获取实时数据
        this.listQuery1.pageInfo.pageNum = 1
        this.pageshow1 = false
        this.queryRealData()
        this.$nextTick(() => {
          this.pageshow1 = true
        })
      }
      if (this.activeTab == 'meterReadPane') {
        this.queryMeterRead()// 获取抄表数据
      }
    },
    download () { // 下载
      var param = {
        type: this.typeNum,
        mcuId: this.$route.query.mcuId,
        startDate: new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000,
        endDate: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      if (this.selectDate.length > 0) {
        param.startDate = new Date(this.selectDate[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDate[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      // param.type = this.activeTab == 'broadcastPane' ? 6 : 7
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportBluetoothDetail?mcuId='
      url += param.mcuId + '&type=' + param.type + '&startDate=' + param.startDate + '&endDate=' + param.endDate + '&tem=' + tem
      window.open(url, '_bank')
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryBroadcast()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryBroadcast()
    },
    // 分页----end
    // 分页----start
    handleSizeChange1 (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.queryRealData()
    },
    handleCurrentChange1 (val, e) { // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.queryRealData()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: "微软雅黑";
}
.searchWarp {
  margin-bottom: 10px;
}
</style>
